import * as PIXI from 'pixi.js';
import { WordBox } from './WordBox';
import { WordBoxData } from '../types';

export class WordBoxManager {
  private container: PIXI.Container;

  constructor(container: PIXI.Container) {
    this.container = container;
  }

  public createWordBoxes(data: WordBoxData[], dimension: number): WordBox[] {
    const wordBoxes: WordBox[] = [];
    for (const boxData of data) {
      wordBoxes.push(new WordBox(boxData, dimension, this.container));
    }
    return wordBoxes;
  }

  public clear(): void {
    this.container.removeChildren();
  }
}
